import { render, staticRenderFns } from "./RooMessageWrapper.vue?vue&type=template&id=3e3cf772&scoped=true"
import script from "./RooMessageWrapper.vue?vue&type=script&lang=js"
export * from "./RooMessageWrapper.vue?vue&type=script&lang=js"
import style0 from "./RooMessageWrapper.vue?vue&type=style&index=0&id=3e3cf772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3cf772",
  null
  
)

export default component.exports